import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import MenuButton from "./MenuButton";
import { Commons } from "../../helper/CommonService";
import EditNoteIcon from '@mui/icons-material/EditNote';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import { AccountBalance, AccountBalanceSharp, Logout, Settings } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

function MenuSection({ open, }) {
    const navigate = useNavigate(); // Initialize the navigate function
    const location = useLocation();

    const Keluar = () => {
        Commons.RemoveAuthDataInStorage();
        navigate("/");
    }

    const menuAdminItems = [
        { text: 'Progress', path: '/progress', icon: <HomeIcon></HomeIcon> },
        { text: 'Berkas', path: '/berkas', icon: <EditNoteIcon></EditNoteIcon> },
        { text: 'Bayar', path: '/bayar', icon: <AccountBalanceSharp></AccountBalanceSharp> },
        { text: 'Config', path: '/config', icon: <Settings></Settings> },
        { text: 'Keluar', onclick: Keluar, icon: <Logout></Logout> },
    ];

    const menuItems = [
        { text: 'Halaman Utama', path: '/', icon: <HomeIcon></HomeIcon>, isShowInAuthMode: false },
        { text: 'Pengisian Data', path: '/main', icon: <EditNoteIcon></EditNoteIcon>, isShowInAuthMode: true },
        { text: 'Pendaftaran', path: '/daftar', icon: <EditNoteIcon></EditNoteIcon>, isShowInAuthMode: false },
        { text: 'Informasi', path: '/informasi', icon: <InfoIcon></InfoIcon>, isShowInAuthMode: false },
        { text: 'Keluar', onclick: Keluar, icon: <Logout></Logout>, isShowInAuthMode: true },
    ];

    const loadMenus = () => {
        if (Commons.IsAdmin()) {
            return menuAdminItems;
        }
        return filterMenu(menuItems);
    }

    const filterMenu = (menuItems) => {
        if (Commons.IsAuth()) {
            return menuItems.filter((menu) => {
                return menu.isShowInAuthMode === true
            })
        } else {
            return menuItems.filter((menu) => menu.isShowInAuthMode === false);
        }
    }

    return (
        <>
            <List>
                {
                    loadMenus().map((item) => {
                        return (
                            <>
                                <ListItem disablePadding sx={{ display: 'block' }}>
                                    <MenuButton item={item} location={location} open={open}>
                                        <ListItemIcon
                                            sx={[
                                                {
                                                    minWidth: 0,
                                                    justifyContent: 'center',
                                                },
                                                open
                                                    ? {
                                                        mr: 3,
                                                    }
                                                    : {
                                                        mr: 'auto',
                                                    },
                                                "/" + location.pathname.split("/")[1] === item.path ? {
                                                    color: 'black'
                                                } :
                                                    {
                                                        color: 'inherit'
                                                    }
                                            ]}
                                        >
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={item.text}
                                            sx={[
                                                open
                                                    ? {
                                                        opacity: 1,
                                                    }
                                                    : {
                                                        opacity: 0,
                                                    },
                                            ]}
                                        />
                                    </MenuButton>
                                </ListItem>
                            </>
                        )
                    })
                }
            </List>
        </>
    )
}

export default MenuSection;